import _ from 'lodash';

import { TwTheme } from '../../Tw';
import { getBestContrastColor } from '../common/color.helper';
import { NamedColors } from './namedColors.types';
// Local Storage Version
export const NAMED_COLORS_VERSION = '2025.07.06';

const colors = TwTheme.extend.colors;

export const namedSystemColors: Record<string, [string, string]> = {
  UNDEFINED: [colors.location?.DEFAULT, null],
  'A+': [
    colors.categoryABCXYZ['A+'],
    getBestContrastColor(colors.categoryABCXYZ['A+']),
  ],
  A: [colors.categoryABCXYZ.A, getBestContrastColor(colors.categoryABCXYZ.A)],
  B: [colors.categoryABCXYZ.B, getBestContrastColor(colors.categoryABCXYZ.B)],
  C: [colors.categoryABCXYZ.C, getBestContrastColor(colors.categoryABCXYZ.C)],
  D: [colors.categoryABCXYZ.D, getBestContrastColor(colors.categoryABCXYZ.D)],
  'Dead Stock': [
    colors.categoryABCXYZ.deadStock,
    getBestContrastColor(colors.categoryABCXYZ.deadStock),
  ],
  PICKING: [
    colors.ActivityEventProcessType.PICKING,
    getBestContrastColor(colors.ActivityEventProcessType.PICKING),
  ],

  REPLENISHMENT: [
    colors.ActivityEventProcessType.REPLENISHMENT,
    getBestContrastColor(colors.ActivityEventProcessType.REPLENISHMENT),
  ],
  REASSIGN: [
    colors.ActivityEventProcessType.REASSIGN,
    getBestContrastColor(colors.ActivityEventProcessType.REASSIGN),
  ],
  PUTAWAY: [
    colors.ActivityEventProcessType.PUTAWAY,
    getBestContrastColor(colors.ActivityEventProcessType.PUTAWAY),
  ],
  PACKING: [
    colors.ActivityEventProcessType.PACKING,
    getBestContrastColor(colors.ActivityEventProcessType.PACKING),
  ],
  STACKING: [
    colors.ActivityEventProcessType.STACKING,
    getBestContrastColor(colors.ActivityEventProcessType.STACKING),
  ],
  MOVE: [
    colors.ActivityEventProcessType.MOVE,
    getBestContrastColor(colors.ActivityEventProcessType.MOVE),
  ],
  ALLOCATE: [
    colors.ActivityEventProcessType.ALLOCATE,
    getBestContrastColor(colors.ActivityEventProcessType.ALLOCATE),
  ],
  STAGING: [
    colors.ActivityEventProcessType.STAGING,
    getBestContrastColor(colors.ActivityEventProcessType.STAGING),
  ],
  UNLOADING: [
    colors.ActivityEventProcessType.UNLOADING,
    getBestContrastColor(colors.ActivityEventProcessType.UNLOADING),
  ],
  SLOTTING: [
    colors.ActivityEventProcessType.SLOTTING,
    getBestContrastColor(colors.ActivityEventProcessType.SLOTTING),
  ],
  DISPATCH: [
    colors.ActivityEventProcessType.DISPATCH,
    getBestContrastColor(colors.ActivityEventProcessType.DISPATCH),
  ],
  SORTING: [
    colors.ActivityEventProcessType.SORTING,
    getBestContrastColor(colors.ActivityEventProcessType.SORTING),
  ],
  QUALITY_CONTROL: [
    colors.ActivityEventProcessType.QUALITY_CONTROL,
    getBestContrastColor(colors.ActivityEventProcessType.QUALITY_CONTROL),
  ],
  INVENTORY: [
    colors.ActivityEventProcessType.INVENTORY,
    getBestContrastColor(colors.ActivityEventProcessType.INVENTORY),
  ],
  INVENTORY_COUNT: [
    colors.ActivityEventProcessType.INVENTORY_COUNT,
    getBestContrastColor(colors.ActivityEventProcessType.INVENTORY_COUNT),
  ],
  VALUE_ADD: [
    colors.ActivityEventProcessType.VALUE_ADD,
    getBestContrastColor(colors.ActivityEventProcessType.VALUE_ADD),
  ],
  KITTING: [
    colors.ActivityEventProcessType.KITTING,
    getBestContrastColor(colors.ActivityEventProcessType.KITTING),
  ],
  DECONSOLIDATION: [
    colors.ActivityEventProcessType.DECONSOLIDATION,
    getBestContrastColor(colors.ActivityEventProcessType.DECONSOLIDATION),
  ],
  LABELING: [
    colors.ActivityEventProcessType.LABELING,
    getBestContrastColor(colors.ActivityEventProcessType.LABELING),
  ],
  MARSHALLING: [
    colors.ActivityEventProcessType.MARSHALLING,
    getBestContrastColor(colors.ActivityEventProcessType.MARSHALLING),
  ],
  RETURNS_PROCESSING: [
    colors.ActivityEventProcessType.RETURNS_PROCESSING,
    getBestContrastColor(colors.ActivityEventProcessType.RETURNS_PROCESSING),
  ],
  SHIPPING: [
    colors.ActivityEventProcessType.SHIPPING,
    getBestContrastColor(colors.ActivityEventProcessType.SHIPPING),
  ],
  TRANSPORT: [
    colors.ActivityEventProcessType.TRANSPORT,
    getBestContrastColor(colors.ActivityEventProcessType.TRANSPORT),
  ],
  MAINTENANCE: [
    colors.ActivityEventProcessType.MAINTENANCE,
    getBestContrastColor(colors.ActivityEventProcessType.MAINTENANCE),
  ],
  CROSSDOCKING: [
    colors.ActivityEventProcessType.CROSSDOCKING,
    getBestContrastColor(colors.ActivityEventProcessType.CROSSDOCKING),
  ],
  MANAGEMENT: [
    colors.ActivityEventProcessType.MANAGEMENT,
    getBestContrastColor(colors.ActivityEventProcessType.MANAGEMENT),
  ],
  MANAGEMENT_YARD: [
    colors.ActivityEventProcessType.MANAGEMENT_YARD,
    getBestContrastColor(colors.ActivityEventProcessType.MANAGEMENT_YARD),
  ],
  MANAGEMENT_DATA: [
    colors.ActivityEventProcessType.MANAGEMENT_DATA,
    getBestContrastColor(colors.ActivityEventProcessType.MANAGEMENT_DATA),
  ],
  MANAGEMENT_WMS: [
    colors.ActivityEventProcessType.MANAGEMENT_WMS,
    getBestContrastColor(colors.ActivityEventProcessType.MANAGEMENT_WMS),
  ],
  SYSTEM: [
    colors.ActivityEventProcessType.SYSTEM,
    getBestContrastColor(colors.ActivityEventProcessType.SYSTEM),
  ],
  IDENTIFICATION: [
    colors.ActivityEventProcessType.IDENTIFICATION,
    getBestContrastColor(colors.ActivityEventProcessType.IDENTIFICATION),
  ],
  OTHER: [
    colors.ActivityEventProcessType.OTHER,
    getBestContrastColor(colors.ActivityEventProcessType.OTHER),
  ],
  IGNORE: [
    colors.ActivityEventProcessType.IGNORE,
    getBestContrastColor(colors.ActivityEventProcessType.IGNORE),
  ],

  // Throughput metrics
  eventsCount: [
    colors.eventMetricTypes.eventsCount,
    getBestContrastColor(colors.eventMetricTypes.eventsCount),
  ],
  uomCount: [
    colors.eventMetricTypes.uomCount,
    getBestContrastColor(colors.eventMetricTypes.uomCount),
  ],
  uniqLocationsCount: [
    colors.eventMetricTypes.uniqLocationsCount,
    getBestContrastColor(colors.eventMetricTypes.uniqLocationsCount),
  ],
  visitsCount: [
    colors.eventMetricTypes.visitsCount,
    getBestContrastColor(colors.eventMetricTypes.visitsCount),
  ],

  // Time metrics - employee activity and idle times
  totalEmployeeActivityDuration: [
    colors.eventMetricTypes.totalEmployeeActivityDuration,
    getBestContrastColor(colors.eventMetricTypes.totalEmployeeActivityDuration),
  ],
  totalIdleDurationShiftStart: [
    colors.eventMetricTypes.totalIdleDurationShiftStart,
    getBestContrastColor(colors.eventMetricTypes.totalIdleDurationShiftStart),
  ],
  totalIdleDurationShiftEnd: [
    colors.eventMetricTypes.totalIdleDurationShiftEnd,
    getBestContrastColor(colors.eventMetricTypes.totalIdleDurationShiftEnd),
  ],
  totalIdleDurationBetweenJobs: [
    colors.eventMetricTypes.totalIdleDurationBetweenJobs,
    getBestContrastColor(colors.eventMetricTypes.totalIdleDurationBetweenJobs),
  ],

  // Weight and volume metrics
  totalWeight: [
    colors.eventMetricTypes.totalWeight,
    getBestContrastColor(colors.eventMetricTypes.totalWeight),
  ],
  totalVolume: [
    colors.eventMetricTypes.totalVolume,
    getBestContrastColor(colors.eventMetricTypes.totalVolume),
  ],

  // Job metrics
  jobsCount: [
    colors.eventMetricTypes.jobsCount,
    getBestContrastColor(colors.eventMetricTypes.jobsCount),
  ],
  jobGroupsCount: [
    colors.eventMetricTypes.jobGroupsCount,
    getBestContrastColor(colors.eventMetricTypes.jobGroupsCount),
  ],

  // Analyzed cost and duration metrics
  analyzedCost: [
    colors.eventMetricTypes.analyzedCost,
    getBestContrastColor(colors.eventMetricTypes.analyzedCost),
  ],
  analyzedDuration: [
    colors.eventMetricTypes.analyzedDuration,
    getBestContrastColor(colors.eventMetricTypes.analyzedDuration),
  ],
  analyzedDistance: [
    colors.eventMetricTypes.analyzedDistance,
    getBestContrastColor(colors.eventMetricTypes.analyzedDistance),
  ],

  // Traveling start metrics
  analyzedDurationTravellingStart: [
    colors.eventMetricTypes.analyzedDurationTravellingStart,
    getBestContrastColor(
      colors.eventMetricTypes.analyzedDurationTravellingStart,
    ),
  ],
  analyzedDistanceTravellingStart: [
    colors.eventMetricTypes.analyzedDistanceTravellingStart,
    getBestContrastColor(
      colors.eventMetricTypes.analyzedDistanceTravellingStart,
    ),
  ],
  analyzedCostTravellingStart: [
    colors.eventMetricTypes.analyzedCostTravellingStart,
    getBestContrastColor(colors.eventMetricTypes.analyzedCostTravellingStart),
  ],

  // Traveling end metrics
  analyzedDurationTravellingEnd: [
    colors.eventMetricTypes.analyzedDurationTravellingEnd,
    getBestContrastColor(colors.eventMetricTypes.analyzedDurationTravellingEnd),
  ],
  analyzedDistanceTravellingEnd: [
    colors.eventMetricTypes.analyzedDistanceTravellingEnd,
    getBestContrastColor(colors.eventMetricTypes.analyzedDistanceTravellingEnd),
  ],
  analyzedCostTravellingEnd: [
    colors.eventMetricTypes.analyzedCostTravellingEnd,
    getBestContrastColor(colors.eventMetricTypes.analyzedCostTravellingEnd),
  ],

  // Traveling internal metrics
  analyzedDurationTravellingInternal: [
    colors.eventMetricTypes.analyzedDurationTravellingInternal,
    getBestContrastColor(
      colors.eventMetricTypes.analyzedDurationTravellingInternal,
    ),
  ],
  analyzedDistanceTravellingInternal: [
    colors.eventMetricTypes.analyzedDistanceTravellingInternal,
    getBestContrastColor(
      colors.eventMetricTypes.analyzedDistanceTravellingInternal,
    ),
  ],
  analyzedCostTravellingInternal: [
    colors.eventMetricTypes.analyzedCostTravellingInternal,
    getBestContrastColor(
      colors.eventMetricTypes.analyzedCostTravellingInternal,
    ),
  ],

  // Traveling vertical metrics
  analyzedDurationTravellingVertical: [
    colors.eventMetricTypes.analyzedDurationTravellingVertical,
    getBestContrastColor(
      colors.eventMetricTypes.analyzedDurationTravellingVertical,
    ),
  ],
  analyzedCostTravellingVertical: [
    colors.eventMetricTypes.analyzedCostTravellingVertical,
    getBestContrastColor(
      colors.eventMetricTypes.analyzedCostTravellingVertical,
    ),
  ],
  analyzedDistanceTravellingVertical: [
    colors.eventMetricTypes.analyzedDistanceTravellingVertical,
    getBestContrastColor(
      colors.eventMetricTypes.analyzedDistanceTravellingVertical,
    ),
  ],

  // Handling metrics
  analyzedDurationHandling: [
    colors.eventMetricTypes.analyzedDurationHandling,
    getBestContrastColor(colors.eventMetricTypes.analyzedDurationHandling),
  ],
  analyzedCostHandling: [
    colors.eventMetricTypes.analyzedCostHandling,
    getBestContrastColor(colors.eventMetricTypes.analyzedCostHandling),
  ],

  // Picking metrics
  analyzedDurationPicking: [
    colors.eventMetricTypes.analyzedDurationPicking,
    getBestContrastColor(colors.eventMetricTypes.analyzedDurationPicking),
  ],
  analyzedCostPicking: [
    colors.eventMetricTypes.analyzedCostPicking,
    getBestContrastColor(colors.eventMetricTypes.analyzedCostPicking),
  ],

  // Reordering metrics
  analyzedDurationReordering: [
    colors.eventMetricTypes.analyzedDurationReordering,
    getBestContrastColor(colors.eventMetricTypes.analyzedDurationReordering),
  ],
  analyzedCostReordering: [
    colors.eventMetricTypes.analyzedCostReordering,
    getBestContrastColor(colors.eventMetricTypes.analyzedCostReordering),
  ],
};

export const commonColors: NamedColors = {
  id: 'policy',
  title: 'Policy Colours',
  colors: {
    BABY: [
      colors.categoryPolicy.BABY,
      getBestContrastColor(colors.categoryPolicy.BABY),
    ],
    AEROSOLS: [
      colors.categoryPolicy.AEROSOLS,
      getBestContrastColor(colors.categoryPolicy.AEROSOLS),
    ],
    FLAMMABLES: [
      colors.categoryPolicy.FLAMMABLES,
      getBestContrastColor(colors.categoryPolicy.FLAMMABLES),
    ],
    HEALTHCARE: [
      colors.categoryPolicy.HEALTHCARE,
      getBestContrastColor(colors.categoryPolicy.HEALTHCARE),
    ],
    HYPOCHLORITES: [
      colors.categoryPolicy.HYPOCHLORITES,
      getBestContrastColor(colors.categoryPolicy.HYPOCHLORITES),
    ],
    HOUSEHOLD: [
      colors.categoryPolicy.HOUSEHOLD,
      getBestContrastColor(colors.categoryPolicy.HOUSEHOLD),
    ],
    ACIDS: [
      colors.categoryPolicy.ACIDS,
      getBestContrastColor(colors.categoryPolicy.ACIDS),
    ],
    PAPERWORK: [
      colors.categoryPolicy.PAPERWORK,
      getBestContrastColor(colors.categoryPolicy.PAPERWORK),
    ],
    CONSUMABLES: [
      colors.categoryPolicy.CONSUMABLES,
      getBestContrastColor(colors.categoryPolicy.CONSUMABLES),
    ],
    CHARITY: [
      colors.categoryPolicy.CHARITY,
      getBestContrastColor(colors.categoryPolicy.CHARITY),
    ],
    OVERSIZED: [
      colors.categoryPolicy.OVERSIZED,
      getBestContrastColor(colors.categoryPolicy.OVERSIZED),
    ],
    APIS: [
      colors.categoryPolicy.APIS,
      getBestContrastColor(colors.categoryPolicy.APIS),
    ],
    PACKAGING: [
      colors.categoryPolicy.PACKAGING,
      getBestContrastColor(colors.categoryPolicy.PACKAGING),
    ],
  },
};

export const hazardColors: NamedColors = {
  id: 'hazard',
  title: 'Hazard (COMAH) Colours',
  colors: {
    AEROSOLS: [
      colors.categoryHazard.AEROSOLS,
      getBestContrastColor(colors.categoryHazard.AEROSOLS),
    ],
    FLAMMABLES: [
      colors.categoryHazard.FLAMMABLES,
      getBestContrastColor(colors.categoryHazard.FLAMMABLES),
    ],
    HYPOCHLORITES: [
      colors.categoryHazard.HYPOCHLORITES,
      getBestContrastColor(colors.categoryHazard.HYPOCHLORITES),
    ],
    ACIDS: [
      colors.categoryHazard.ACIDS,
      getBestContrastColor(colors.categoryHazard.ACIDS),
    ],
  },
};

export const namedColors = _.keyBy([commonColors, hazardColors], nc => nc.id);
